import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Organization } from '../../types/organization.type';
import { NavigationService } from '../../services/navigation.service';
import { ROUTES } from '../../constants/routes';

@Component({
  selector: 'app-event-by',
  templateUrl: './event-by.component.html',
  styleUrls: ['./event-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventByComponent {
  protected readonly ROUTES = ROUTES;

  @Input() organization: Organization;
  @Input() small = false;

  constructor(private navigation: NavigationService) {}

  goToResultsByOrganizationId(e: MouseEvent): void {
    e.stopPropagation();

    if (!e.ctrlKey) {
      this.navigation.goToResultsByOrganizationId(
        this.organization.organization_id
      );
    }
  }
}
